import { render, staticRenderFns } from "./PlantReact.vue?vue&type=template&id=66e13580&"
import script from "./PlantReact.vue?vue&type=script&lang=js&"
export * from "./PlantReact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports